import { createContext, useContext, useState } from 'react';

const AccessibilityContext = createContext();

export function AccessibilityProvider({ children }) {
  const [colorblindMode, setColorblindMode] = useState('none');

  return (
    <AccessibilityContext.Provider value={{ colorblindMode, setColorblindMode }}>
      <div className={`colorblind-${colorblindMode}`}>
        {children}
      </div>
    </AccessibilityContext.Provider>
  );
}

export function useAccessibility() {
  return useContext(AccessibilityContext);
}
